export default "__VITE_ASSET__BF8GEs6f__"